import {
  updateWidgetOrder,
  updateWidgetProps,
  UPDATE_WIDGET_ORDER_SAGA,
  UPDATE_WIDGET_PROPS_SAGA,
} from "src/redux/actions/widgets";

import { putWidgetOrder, putWidgetProperties } from "src/services/widget";
import { put, takeLatest, select } from "redux-saga/effects";
import { WidgetI } from "src/types/Widget";

const getWidgets = (state): WidgetI[] => {
  return state.widgets;
};

const getIsGlobalRiskMap = (state): boolean => {
  return state.application.isGlobalRiskMap;
};

const getIsSwitchAccountViewOnly = (state): boolean => {
  return !!state.externalAccount?.account;
};

function* updateWidgetOrderSaga({
  oldIndex,
  newIndex,
}: {
  oldIndex: number;
  newIndex: number;
  type: string;
}) {
  if (oldIndex !== newIndex) {
    const widgets: WidgetI[] = yield select(getWidgets);
    const id = widgets[oldIndex].id;
    // Update redux state
    yield put(updateWidgetOrder(oldIndex, newIndex));
    // Save state update to the backend to save
    putWidgetOrder(id, newIndex + 1);
  }
}

function* updateWidgetPropsSaga({
  index,
  props,
}: {
  index: number;
  props: WidgetI;
  type: string;
}) {
  // Update redux state
  yield put(updateWidgetProps(index, props));

  // We do not send backend puts for global error map users to save user prefs
  const isGlobalRiskMap: boolean = yield select(getIsGlobalRiskMap);
  if (isGlobalRiskMap) return;

  // Get the widget id to send to backend
  const widgets: WidgetI[] = yield select(getWidgets);
  const identifier = widgets[index].identifier;
  const id = widgets[index].id;
  // Save the widget property state to the backend
  const isViewOnly = yield select(getIsSwitchAccountViewOnly);
  if (!isViewOnly) putWidgetProperties(identifier, id, props);
}

function* widgetSaga() {
  yield takeLatest(UPDATE_WIDGET_ORDER_SAGA, updateWidgetOrderSaga);
  yield takeLatest(UPDATE_WIDGET_PROPS_SAGA, updateWidgetPropsSaga);
}

export default widgetSaga;
